// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-JP3":"JP3_dpu-detail-JP3__HH4LC"};